<template>
    <div class="unilateral-ctask clearfloat" v-if="ctaskData">
        <div class="unilateral-ctask-item float-left ctask_title_info">
            <span>{{ctaskData.names}}</span> -- <span>{{ctaskData.user}}</span>
        </div>
        <div class="unilateral-ctask-item float-left">
            <span>{{ctaskData.bourse}}</span>
        </div>
        <div class="unilateral-ctask-item float-left ctask_ratio">
            <span>杠杆率(%)/ {{ctaskData.ratio}}</span>
        </div>
        <div class="unilateral-ctask-item float-left ctask_strategy_ratio">
            <span>策略比例(%) /{{ctaskData.strategy_ratio}}</span>
        </div>
        <div class="unilateral-ctask-item float-left cqty">
            <span>{{ctaskData.qty}}</span>
        </div>
        <div class="unilateral-ctask-item float-left">
            <span>{{ctaskData.createtime}}</span>
        </div>
        <div class="unilateral-ctask-item float-left">
            <span class="strage_status"
            :style="{'background-color': ctaskColorStatus(ctaskData.status)}"
            >{{taskStatue(ctaskData.status)}}</span>
        </div>
        
        <div class="unilateral-ctask-item float-left">
            <el-dropdown trigger="click">
                <el-button class="table-btn task_btn_style">操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="taskStateChange('start', ctaskData.id)">立即启动</el-dropdown-item>
                    <el-dropdown-item @click.native="taskStateChange('startDelay', ctaskData.id)">延时启动</el-dropdown-item>
                    <el-dropdown-item @click.native="handleLoss(ctaskData.id)">继续跟随</el-dropdown-item>
                    <el-dropdown-item @click.native="taskStateChange('stop', ctaskData.id)">停止</el-dropdown-item>
                    <el-dropdown-item @click.native="taskDelete(ctaskData.id)">删除</el-dropdown-item>
                    <el-dropdown-item @click.native="taskEdit(ctaskData.id, ctaskData.strategy_id)">编辑</el-dropdown-item>
                    <el-dropdown-item @click.native="taskDetail(ctaskData.id)">详情</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button class="table-btn task_btn_style"
            @click="manualEvent(ctaskData.bourse, ctaskData.id)">手动</el-button>
        </div>

        <!-- 任务编辑 -->
        <TaskEditDialog ref="taskEditDialog"></TaskEditDialog>

        <el-dialog title="手动" :visible.sync="manualFlag">
            <el-form label-width="100px">
                <el-form-item label="委托价格">
                    <el-input v-model="manualParam.price"></el-input>
                </el-form-item>
                <el-form-item label="委托量">
                    <el-input v-model="manualParam.amount" placeholder="期货时，单位为张，现货为颗"></el-input>
                </el-form-item>
                <el-form-item label="合约类型">
                    <el-select v-model="manualParam.type" placeholder="请选择合约类型" @change="tradeChangeEvent">
                        <el-option v-for="(trade, index) in tradeTypeObj" :key="'trade'+index" :label="trade" :value="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交易类型">
                    <el-select v-model="manualParam.direction" placeholder="请选择交易类型">
                        <el-option v-for="(trade, index) in tradeDirection" :key="'trade'+index" :label="index" :value="trade"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="价格方式">
                    <el-select v-model="manualParam.way" placeholder="请选择交易方向">
                        <el-option label="市价" value="1"></el-option>
                        <el-option label="限价" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币对">
                    <el-input class="match_input" v-model="manualParam.symbol" @input="matchValue" @blur="loseForce"
                    placeholder="请输入币对"></el-input>
                    <ul class="input_dropdown" style="display: none;">
                        <li v-for="(i, index) in currencyMatchList" :key="'match_'+index" 
                        @click="currencySelect(i)">{{i}}</li>
                    </ul>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="manualFlag = false">取消</el-button>
                <el-button type="primary" @click="submitManual">确定</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
// /* eslint-disabled */
import { mapState } from "vuex";
import { put, get, post } from "@/api/index";
import TaskEditDialog from "@/components/unilateral/Unilateral-task-edit.vue";
import { postRestoreTask } from "@/api/api";
 
export default {
    components: {
        TaskEditDialog
    },
    data: function () {
        return {
            formParam: {},
            dialogType: 'add',
            taskEditFlag: false,
            currencyType: true,
            apiAllData: [],
            priority: 0,
            newStrategyArr:[],
            manualFlag: false,
            manualParam: {},
            currencyMatchList: [],
            tradeDirection: '',
            thisBourse: '',
            currencys: {},
        }
    },
    props: [
        "ctaskData"
    ],
    mounted() {

    },
    computed: {
        ...mapState([
            "token",
            "userLevel",
            "tradeTypeObj"
        ])
    },
    methods: {

        // 任务状态判断
        taskStatue(state) {
            if (state == '1') return '自动';
            else if (state == '0') return '停止';
            else if (state == '2') return '保值';
            else if (state == '3') return '延时';
            else if (state == '4') return '止损';
        },

        // 任务操作
        taskStateChange(flag, id) {
            var url = this.$url_LN_local + '/put/task/state';
            var param = {
                'token': this.token,
                'apis': [id]
            };

            if (flag == 'start') {
                param['state'] = 1;
            } else if (flag == 'stop') {
                param['state'] = 0;
            } else if (flag == 'startDelay') {
                param['state'] = 3;
            }

            put(url, param).then(res => {
                if (res.code === 200) {
                    
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 删除 任务
        taskDelete(id) {

            this.$confirm('是否删除该API?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var url = this.$url_LN_local + '/delete/task';
                var param = {
                    token: this.token,
                    apiId: id
                };

                post(url, JSON.stringify(param)).then(res => {
                    if (res.code == 200) {
                        this.$notify.info({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        });
                    } else {
                        this.$notify.error({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        });
                    }
                })
            })
        },

        // 任务编辑
        taskEdit(id, s_id) {
            this.dialogType = 'edit';
            this.apiVerifyColor = '';
            this.apiVerifyStatus = '';
            this.$refs.taskEditDialog.initDialog(id, this.dialogType);
        },

        // 币对 选择事件
        currencySelect(cur) {
            this.manualParam.symbol = cur;
            $('.input_dropdown').css('display', 'none');
        },

        // 币对匹配
        matchValue(e) {
            this.currencyMatchList = []
            for (var i=0;i<this.currencys.length; i++) {
                if (this.currencys[i].indexOf(e) !== -1) {
                    this.currencyMatchList.push(this.currencys[i])
                }
            }
            var width = $('.match_input').width();

            $('.input_dropdown').css({
                'display': '',
                "width": width+"px"
            });
        },

        // 失去焦点
        loseForce() {
            if (!this.manualParam.symbol) {
                $('.input_dropdown').css('display', 'none');
            }
        },

        // 手动（新）提交
        submitManual() {
            // console.log(this.manualParam, this.apiId);
            var url = this.$url_LN_local + '/manual/trading';
            var param = this.manualParam;
            param['token'] = this.token;

            post(url, param).then(res => {
                if (res.code === 200) {
                    this.manualFlag = false;
                    this.$notify.info({
                        message: '操作成功',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 100
                    })
                }
            });

        },

        // 交易类型 切换事件
        tradeChangeEvent(e) {
            if (e == 'SS') {// 现货
                this.tradeDirection = {"买": 1, "卖": 2};
            } else {
                this.tradeDirection = {'开多': 1,"开空": 2, "平多": 3, "平空": 4};
            }

            this.getCurrencys(e);
        },

        // 手动显示窗口
        manualEvent(bourse, id) {
            this.manualFlag = true;
            this.manualParam = {};
            this.thisBourse = bourse;
            this.manualParam['apiId'] = id;
        },

        // 获取币对
        getCurrencys(tps) {
            var url = this.$url_LN_local + '/get/currency/information';
            var param = {
                "bourse": this.thisBourse,
                "types": tps
            };

            get(url, param).then(res => {
                if (res.code == 200) {
                    this.currencys = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    })
                }
            });
        },

        // 显示详情
        taskDetail(taskId) {
            this.$router.push({
                path: '/main/index/api/detail',
                query: {
                    key: taskId
                }
            })
        },
        // 颜色判断
        ctaskColorStatus(flag) {
            let flags = String(flag);
            if (flags == '1') {
                return "#1aa094";
            } else if (flags == '2') {
                return '#1a76b2';
            } else if (flags == '3') {
                return '#1aa094';
            } else if (flags == '4') {
                return '#ec3838';
            }
            return '#db5634';
        },
        // 恢复止损
        handleLoss(taskId) {
            this.$confirm('是否继续跟随？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                postRestoreTask({
                    token: this.token,
                    taskId: String(taskId)
                }).then(res => {
                    this.$notify.info({
                        title: '提示',
                        message: res.info,
                        offset: 200
                    });
                }).catch(err => {
                    this.$notify.error({
                        title: '提示',
                        message: res.info,
                        offset: 200
                    });
                });
            }).catch(() => {

            });
        }
    }
}
</script>

<style lang="scss">
.unilateral-ctask {
    background-color: #262829;
    box-shadow: inset 0 0 6px #1e1e1e;
    padding: 5px 30px;

    .el-dialog__header {
        background-color: #fff !important;
        padding: 10px !important;
        border-bottom: 1px solid #e3e3e6;
    }

    .el-form{
        .el-select {
            width: 100%;
        }
    }

    .strage_status {
        border-radius: 3px;
        color: #fff;
        padding: 3px 6px;
        box-sizing: border-box;
        display: inline-block;
        font-size: 12px;
    }

    .task_btn_style {
        font-size: 12px;
        margin-left: 5px;
    }
    .unilateral-ctask-item {
        margin: 5px 10px;
        line-height: 36px;
        font-size: 12px;
    }
    .ctask_title_info {
        font-size: 14px;
        // min-width: 120px;
        width: 200px;
        text-align: left;
    }
    .cqty {
        font-size: 14px;
        // min-width: 120px;
        width: 110px;
        text-align: left;
    }
    .ctask_ratio {
        min-width: 120px;
    }
}
</style>
